import { __decorate } from "tslib";
import { Component, Vue, Prop, Watch, Model } from "vue-property-decorator";
let PiDatePicke = class PiDatePicke extends Vue {
    constructor() {
        super(...arguments);
        this.pickeInputCloseIcon = false;
        this.visible = false;
        this.active = "";
        this.selectTimeList = [];
        this.selectTimeListTow = [];
        this.pickeInputActive = false;
        this.startInputActive = false;
        this.endInputActive = false;
        this.timePage = 0;
        this.timePageSize = 12;
        this.toast = 0;
        this.start = "";
        this.end = "";
        this.mouseItem = "";
        this.timeValue = [];
        this.isAddClick = false;
    }
    "Watch.type"() {
        this.init();
        this.returnData();
    }
    "Watch.modelValue"(val, old) {
        if (typeof val == "object" &&
            typeof old == "object" &&
            Object.prototype.toString.call(val).slice(8, -1) === "Array") {
            if (val.join("-") != old.join("-")) {
                this.init();
                // this.returnData();
            }
        }
        else {
            if (val != old) {
                this.init();
                this.returnData();
            }
        }
    }
    // private month = "";
    /**
     * 第一个框的标题
     */
    get selectTimeListTitle() {
        let text = "";
        if (this.type == "year" || this.type == "yearrange") {
            text =
                (this.selectTimeList[0] ? this.selectTimeList[0].name : "") +
                    "-" +
                    (this.selectTimeList[this.selectTimeList.length - 1]
                        ? this.selectTimeList[this.selectTimeList.length - 1].name
                        : "");
        }
        else if (this.type == "month" || this.type == "monthrange") {
            let t = this.selectTimeList[0] ? this.selectTimeList[0].value : "";
            text = (t + "").split("-")[0];
        }
        return text;
    }
    /**
     * 第二个框的标题
     */
    get selectTimeListTowTitle() {
        let text = "";
        if (this.type == "year" || this.type == "yearrange") {
            text =
                (this.selectTimeListTow[0] ? this.selectTimeListTow[0].name : "") +
                    "-" +
                    (this.selectTimeListTow[this.selectTimeListTow.length - 1]
                        ? this.selectTimeListTow[this.selectTimeListTow.length - 1].name
                        : "");
        }
        else if (this.type == "month" || this.type == "monthrange") {
            let t = this.selectTimeListTow[0] ? this.selectTimeListTow[0].value : "";
            text = (t + "").split("-")[0];
        }
        return text;
    }
    /**
     * 年/月 鼠标移入，显示删除
     */
    pickeInputMouseEnter() {
        if (this.start && this.end) {
            this.pickeInputCloseIcon = true;
        }
    }
    /**
     * 年/月 鼠标移出，隐藏删除
     */
    pickeInputMouseLeave() {
        if (this.pickeInputCloseIcon) {
            this.pickeInputCloseIcon = false;
        }
    }
    /**
     * input 清除
     */
    inputClear() {
        if (this.visible) {
            this.handleClose();
        }
        if (this.type == "year" || this.type == "month") {
            this.active = "";
        }
        else if (this.type == "monthrange" || this.type == "yearrange") {
            this.start = "";
            this.end = "";
        }
        this.returnData();
    }
    /**
     * 开始时间聚焦
     */
    startInputFocus() {
        if (!this.disabled) {
            this.handleOpen();
            this.pickeInputActive = true;
            this.startInputActive = true;
        }
    }
    /**
     * 开始时间聚失去焦
     */
    startInputBlur() {
        this.startInputActive = false;
    }
    /**
     * 结束时间聚焦
     */
    endInputFocus() {
        if (!this.disabled) {
            this.handleOpen();
            this.endInputActive = true;
        }
    }
    /**
     * 结束时间聚失去焦
     */
    endInputBlur() {
        this.endInputActive = false;
    }
    /**
     * 打开日历
     */
    handleOpen() {
        if (!this.visible && !this.disabled) {
            this.visible = true;
        }
    }
    /**
     * 关闭日历
     */
    handleClose() {
        this.visible = false;
        this.mouseItem = "";
        if (this.pickeInputActive) {
            this.pickeInputActive = false;
        }
    }
    /**
     * 时间选择
     */
    timeClick(item) {
        if (this.type == "year" || this.type == "month") {
            this.active = item.value;
            this.returnData();
            this.handleClose();
        }
        else if (this.type == "yearrange" || this.type == "monthrange") {
            if (this.start == "" && this.end == "") {
                this.start = item.value;
            }
            else if (this.start != "" && this.end == "") {
                if (item.value < this.start) {
                    this.end = this.start + "";
                    this.start = item.value;
                }
                else {
                    this.end = item.value;
                }
                this.returnData();
                this.handleClose();
            }
            else if (this.start != "" && this.end != "") {
                this.start = item.value;
                this.end = "";
            }
        }
    }
    timeChange(val) {
        this.timeValue = val;
        this.returnData();
    }
    /**
     * 返回数据
     */
    returnData() {
        if (this.type == "year" || this.type == "month") {
            this.$emit("value", this.active);
            this.$emit("on-change", this.active);
        }
        else if (this.type == "yearrange" || this.type == "monthrange") {
            this.$emit("value", [this.start, this.end]);
            this.$emit("on-change", [this.start, this.end]);
        }
        else if (this.type == "daterange") {
            this.$emit("value", this.timeValue);
            this.$emit("on-change", this.timeValue);
        }
    }
    /**
     * 鼠标移入
     */
    handleMouseEnter(item) {
        if (this.start != "" && this.end == "") {
            this.mouseItem = item.value;
        }
    }
    /**
     * 今年点击
     */
    toYearClick() {
        const d = new Date();
        let item = "";
        if (this.type == "year") {
            item = d.getFullYear() + "";
        }
        this.timeClick({ name: item, value: item });
        this.selectTimeList = this.getYearList(this.getSelectIndex(item));
    }
    /**
     * 本月点击
     */
    toTonthClick() {
        const d = new Date();
        let year = d.getFullYear();
        let m = d.getMonth() + 1;
        let month = m < 10 ? "0" + m : m + "";
        this.timeClick({ name: m + "月", value: year + "-" + month });
        this.timePage = year;
        this.selectTimeList = this.getMonth(this.timePage + "");
    }
    /**
     * 重置
     */
    reset() {
        this.selectTimeList = [];
        this.selectTimeListTow = [];
        this.timePage = 0;
        this.toast = 0;
        this.start = "";
        this.end = "";
        this.mouseItem = "";
    }
    /**
     * 初始化
     */
    init() {
        this.reset();
        if (this.type == "year") {
            let selectIndex = 0;
            if (this.modelValue &&
                Number(this.modelValue) >= this.yearMin &&
                Number(this.modelValue) <= this.yearMax) {
                this.active = this.modelValue + "";
                // 找出 value 在哪一页
                selectIndex = this.getSelectIndex(this.modelValue + "");
                this.timePage = selectIndex;
            }
            this.selectTimeList = this.getYearList(selectIndex);
            this.toast = Math.floor((this.yearMax - this.yearMin) / this.timePageSize);
        }
        else if (this.type == "yearrange") {
            // 年范围
            let startIndex = 0;
            let endIndex = 0;
            if (Object.prototype.toString.call(this.modelValue).slice(8, -1) === "Array") {
                if (this.modelValue[0] && this.modelValue[1]) {
                    this.start = parseInt(this.modelValue[0]) + "";
                    this.end = parseInt(this.modelValue[1]) + "";
                    startIndex = this.getSelectIndex(this.start + "");
                }
            }
            if (startIndex == endIndex) {
                endIndex = startIndex + 1;
            }
            this.selectTimeList = this.getYearList(startIndex);
            this.selectTimeListTow = this.getYearList(endIndex);
            this.toast = Math.floor((this.yearMax - this.yearMin) / this.timePageSize);
        }
        else if (this.type == "month") {
            const d = new Date();
            if (this.modelValue) {
                let arr = (this.modelValue + "").split("-");
                this.timePage = Number(arr[0]);
                this.active = this.modelValue + "";
            }
            else {
                this.timePage = d.getFullYear();
                this.active = "";
            }
            this.selectTimeList = this.getMonth(this.timePage + "");
            this.toast = this.yearMax + 0;
        }
        else if (this.type == "monthrange") {
            // 月范围
            let startIndex = this.yearMin + 0;
            if (Object.prototype.toString.call(this.modelValue).slice(8, -1) === "Array") {
                if (this.modelValue[0] && this.modelValue[1]) {
                    let arr = (this.modelValue[0] + "").split("-"); // 找出年份
                    startIndex = Number(arr[0]);
                    if (!arr[1]) {
                        this.start = this.modelValue[0] + "-01";
                        this.end = this.modelValue[1] + "-01";
                    }
                    else if (arr[2]) {
                        // 如果还有日
                        this.start = arr[0] + "-" + arr[1];
                        let endArr = (this.modelValue[1] + "").split("-"); // 找出年份
                        this.end = endArr[0] + "-" + endArr[1];
                    }
                    else {
                        this.start = this.modelValue[0];
                        this.end = this.modelValue[1];
                    }
                }
            }
            let endIndex = startIndex + 1;
            this.timePage = startIndex;
            this.toast = this.yearMax + 0;
            this.selectTimeList = this.getMonth(this.timePage + "");
            this.selectTimeListTow = this.getMonth(endIndex + "");
        }
        else if (this.type == "daterange") {
            // 年月日
            if (typeof this.modelValue == "object" &&
                Object.prototype.toString.call(this.modelValue).slice(8, -1) === "Array") {
                let arr = (this.modelValue[0] + "").split("-");
                const d = new Date();
                let year = d.getFullYear();
                let month = d.getMonth() + 1;
                let day = d.getDate();
                if (month < 10) {
                    month = "0" + month;
                }
                if (day < 10) {
                    day = "0" + day;
                }
                if (!arr[2] && arr[1]) {
                    // 没有日
                    this.timeValue = [
                        this.modelValue[0] + "-01",
                        this.modelValue[1] + "-01",
                    ];
                }
                else if (!arr[2] && !arr[1]) {
                    // 没有月日
                    this.timeValue = [
                        this.modelValue[0] + "-01-01",
                        this.modelValue[1] + "-01-31",
                    ];
                }
                else if (!arr[0]) {
                    // 没有年月日
                    this.timeValue = [
                        year + "-" + month + "-01",
                        year + "-" + month + "-" + day,
                    ];
                }
                else {
                    this.timeValue = [this.modelValue[0], this.modelValue[1]];
                }
            }
        }
    }
    /**
     * 获取年 值value 在列表的哪一页
     */
    getSelectIndex(value) {
        let selectIndex = Math.floor((Number(value) - this.yearMin) / this.timePageSize);
        return selectIndex;
    }
    /**
     * 下一页
     */
    nextTimeList() {
        if (this.type == "year") {
            if (this.timePage < this.toast) {
                this.timePage++;
                this.selectTimeList = this.getYearList(this.timePage);
            }
        }
        else if (this.type == "yearrange") {
            if (this.timePage < this.toast - 1) {
                this.timePage++;
                this.selectTimeList = this.getYearList(this.timePage);
                this.selectTimeListTow = this.getYearList(this.timePage + 1);
            }
        }
        else if (this.type == "month") {
            if (this.timePage < this.toast) {
                this.timePage++;
                this.selectTimeList = this.getMonth(this.timePage + "");
            }
        }
        else if (this.type == "monthrange") {
            if (this.timePage < this.toast - 1) {
                this.timePage++;
                this.selectTimeList = this.getMonth(this.timePage + "");
                this.selectTimeListTow = this.getMonth(this.timePage + 1 + "");
            }
        }
    }
    /**
     * 上一页
     */
    previousTimeList() {
        if (this.type == "year") {
            if (this.timePage > 0) {
                this.timePage--;
                this.selectTimeList = this.getYearList(this.timePage);
            }
        }
        else if (this.type == "yearrange") {
            if (this.timePage > 0) {
                this.timePage--;
                this.selectTimeList = this.getYearList(this.timePage);
                this.selectTimeListTow = this.getYearList(this.timePage + 1);
            }
        }
        else if (this.type == "month") {
            if (this.timePage > this.yearMin) {
                this.timePage--;
                this.selectTimeList = this.getMonth(this.timePage + "");
            }
        }
        else if (this.type == "monthrange") {
            if (this.timePage > this.yearMin) {
                this.timePage--;
                this.selectTimeList = this.getMonth(this.timePage + "");
                this.selectTimeListTow = this.getMonth(this.timePage + 1 + "");
            }
        }
    }
    /**
     * 获取日历列表
     */
    getYearList(timePage) {
        let selectTimeList = [];
        let min = timePage * this.timePageSize + this.yearMin;
        let max = min + this.timePageSize;
        for (let i = this.yearMin; i <= this.yearMax; i++) {
            if (i >= min && i < max) {
                selectTimeList.push({
                    value: i + "",
                    name: i + "",
                });
            }
        }
        return selectTimeList;
    }
    /**
     * 获取月份列表
     */
    getMonth(year) {
        let arr = [];
        for (let i = 1; i <= 12; i++) {
            let value = i < 10 ? "0" + i : i;
            arr.push({ name: i + "月", value: year + "-" + value });
        }
        return arr;
    }
    /**
     * 点击框以外的地方关闭
     */
    addClickClose(e) {
        let s1 = this.$refs.s1 || {};
        let s2 = this.$refs.s2 || {};
        if (!s1.contains(e.target) && s2.contains && !s2.contains(e.target)) {
            if (this.visible) {
                this.visible = false;
            }
            if (this.pickeInputActive) {
                this.pickeInputActive = false;
            }
        }
    }
    mounted() {
        this.init();
        if (!this.isAddClick) {
            document.addEventListener("click", this.addClickClose, true);
        }
    }
    activated() {
        if (!this.isAddClick) {
            document.addEventListener("click", this.addClickClose, true);
        }
    }
    deactivated() {
        document.removeEventListener("click", this.addClickClose, true);
    }
    destroyed() {
        document.removeEventListener("click", this.addClickClose, true);
    }
};
__decorate([
    Prop({ default: 999999999 })
], PiDatePicke.prototype, "max", void 0);
__decorate([
    Prop({ default: 0 })
], PiDatePicke.prototype, "min", void 0);
__decorate([
    Prop({ default: false })
], PiDatePicke.prototype, "disabled", void 0);
__decorate([
    Prop({ default: "" })
], PiDatePicke.prototype, "placeholder", void 0);
__decorate([
    Prop({ default: "year" })
], PiDatePicke.prototype, "type", void 0);
__decorate([
    Prop({ default: 2020 })
], PiDatePicke.prototype, "yearMin", void 0);
__decorate([
    Prop({ default: 2100 })
], PiDatePicke.prototype, "yearMax", void 0);
__decorate([
    Watch("type")
], PiDatePicke.prototype, "Watch.type", null);
__decorate([
    Watch("modelValue")
], PiDatePicke.prototype, "Watch.modelValue", null);
__decorate([
    Model("value")
], PiDatePicke.prototype, "modelValue", void 0);
PiDatePicke = __decorate([
    Component
], PiDatePicke);
export default PiDatePicke;
